import { Switch } from '@material-ui/core';
import { useContext } from 'react';
import InsightsFormStateContext from '../useFormState/form.state.context';

const InsightSwitch = ({ insight }) => {
  const { onToggleSwitch } = useContext(InsightsFormStateContext);

  return (
    <Switch
      name={insight.key}
      onClick={onToggleSwitch}
      checked={insight.active}
    />
  );
};

export default InsightSwitch;
